export const MAX_ACTIVE_TOKENS = 2;
export const ROTATE_ACTION_TYPE = 'rotate';
export const REVOKE_ACTION_TYPE = 'revoke';
export const ROTATE_ACTION_DIALOG_TITLE = 'Rotate Token';
export const REVOKE_ACTION_DIALOG_TITLE = 'Revoke Token';
export const ROTATE_ACTION_DIALOG_MESSAGE =
  'Are you sure you want to rotate this token? This action will revoke the current token and generate a new one.';
export const REVOKE_ACTION_DIALOG_MESSAGE =
  'Are you sure you want to revoke this token? This action cannot be undone and the token will no longer be valid.';
